import React, {useEffect} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Faq from "../../../components/faq";
//for redux and saga
import { connect } from "react-redux";
import { getfaqs } from "../../../redux/actions";

const FaqContent = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { getFaqsAction, getfaqsList, loading, error, messages } = props;
  // const [howItWorkData, setHowItWorkData] = useState([])

  console.log("faqs check---", getfaqsList, loading, error, messages);

  React.useEffect(() => {
    // alert('calld')
    fetchData();
  }, []);

  const fetchData = () => {
    // alert("hello")
    getFaqsAction(1);
  };




  return (
    <section className="faqbox-wrap main-faq-wrap pt-100 pb-70">
      <Container>
        <Row>
          <Col md={12}>
            <h2 className="main-title">Frequently Asked Questions</h2>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Faq getfaqsList={getfaqsList} />
          </Col>
        </Row>
        <div className="main-faq-content">
          {/* <Row>
            <Col md={12}>
              <h2 className="main-title">FAQs on Car Rental in Mumbai</h2>
            </Col>
          </Row> */}
          {/* <Row>
            <Col md={12}>
              <Faq title="Cancellation and Returns" />
            </Col>
          </Row> */}

          {/* <Row>
            <Col md={12}>
              <Faq title="Documentation" />
            </Col>
          </Row> */}
          {/* <Row>
            <Col md={12}>
              <Faq title="Payments" />
            </Col>
          </Row> */}
        </div>
      </Container>
    </section>
  );
};

// export default FaqContent;
const mapStateToProps = ({ FAQs }) => {
  // console.log('======', howitwork);
  const { loading, error, messages, getfaqsList } = FAQs;
  return { loading, error, messages, getfaqsList };
};

export default connect(mapStateToProps, {
  getFaqsAction: getfaqs,
})(FaqContent);

